import { render, staticRenderFns } from "./GunBoxList.vue?vue&type=template&id=7b132764&"
import script from "./GunBoxList.vue?vue&type=script&lang=ts&"
export * from "./GunBoxList.vue?vue&type=script&lang=ts&"
import style0 from "./GunBoxList.vue?vue&type=style&index=0&id=7b132764&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports